import React, { useState, useEffect, FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import { equals } from 'ramda';
import { IBindingCallback1, IBindingAction } from '../../common/models/callback';
import { fetchTeamsRoutine } from '../TeamList/routines';
import { IAppState } from '../../common/models/store/IAppState';
import { ITeam } from '../../common/models/team/ITeam';
import { IAssignmentFilter } from '../../common/models/filter/IAssignmentFilter';
import CustomPopover from '../../components/CustomPopover';
import AssignmentFilterBody from '../AssignmentFilterBody';
import TextOverflowTooltip from '../../components/TextOverflowTooltip';
import { getLabel } from '../AssignmentFilterBody/utils';
import { AssignmentFilterType } from '../../common/enums/AssignmentFilterType';
import Icon from '../../components/Icon';
import { User } from '../../common/models/user/User';
import styles from './styles.module.scss';

interface IAssignmentDrodownProps {
  defaultCheckboxChecked?: string[];
  defaultRadioChecked?: AssignmentFilterType;
  onChange: IBindingCallback1<IAssignmentFilter>;
}

const AssignmentDrodown: FunctionComponent<IAssignmentDrodownProps> = ({
  defaultCheckboxChecked,
  defaultRadioChecked,
  onChange
}) => (
  <Card className={styles.dropdown}>
    <div className="p-3">
      <AssignmentFilterBody
        defaultCheckboxChecked={defaultCheckboxChecked}
        defaultRadioChecked={defaultRadioChecked}
        onChange={onChange}
      />
    </div>
  </Card>
);

interface IAssignmentFilterProps {
  onChange: IBindingCallback1<IAssignmentFilter>;
  teams: ITeam[] | null;
  user?: User;
  title?: string;
  defaultTitle?: string;
  defaultCheckboxChecked?: string[];
  defaultRadioChecked?: AssignmentFilterType;
  fetchTeams: IBindingAction;
}

const AssignmentFilter: FunctionComponent<IAssignmentFilterProps> = ({
  onChange,
  teams,
  user = {} as User,
  fetchTeams,
  title = 'Owner',
  defaultTitle,
  defaultCheckboxChecked = [],
  defaultRadioChecked
}) => {
  const [label, setLabel] = useState(
    defaultRadioChecked
      ? getLabel(defaultRadioChecked, user)
      : getLabel(AssignmentFilterType.Me, user)
  );

  const [selectedRadio, setSelectedRadio] = useState(defaultRadioChecked);

  useEffect(() => {
    if (!teams) {
      fetchTeams();
    }
  }, []);

  const changeLabel = (radio: AssignmentFilterType) => {
    setLabel(getLabel(radio, user));
    setSelectedRadio(radio);
  };

  useEffect(() => {
    if (defaultRadioChecked && !equals(defaultRadioChecked, selectedRadio)) {
      changeLabel(defaultRadioChecked);
    }
  }, [defaultRadioChecked]);

  const onUpdateFilter = (data: IAssignmentFilter) => {
    if (data.assigmentType) {
      changeLabel(data.assigmentType);
    }
    onChange(data);
  };

  const Trigger = () => (
    <div className="popup-trigger">
      <div className="d-flex flex-column justify-content-center">
        <TextOverflowTooltip content={label} width={145}>
          <span className="popup-selected">{label}</span>
        </TextOverflowTooltip>
      </div>
      <Icon icon="chevronDownBig" className="popup-chevron" />
    </div>
  );

  return (
    <div className="popup-wrapper">
      <div className="popup-label">
        <FormattedMessage id={title} defaultMessage={defaultTitle || title} />
      </div>
      <CustomPopover
        rootClose
        placement="bottom-start"
        trigger={<Trigger />}
        popoverClassName="popup-filter"
      >
        <AssignmentDrodown
          defaultCheckboxChecked={defaultCheckboxChecked}
          defaultRadioChecked={selectedRadio}
          onChange={onUpdateFilter}
        />
      </CustomPopover>
    </div>
  );
};

const mapStateToProps = ({
  teamList: { teams }, user: { user }
}: IAppState) => ({ teams, user });

const mapDispachToProps = {
  fetchTeams: fetchTeamsRoutine
};

export default connect(mapStateToProps, mapDispachToProps, null, { forwardRef: true })(AssignmentFilter);
